<template>
  <div ref="layout" class="page-query">
    <TableQuery title="要货审批人员批导" :tools="false" />

    <div class="table-container">
      <TableCommon
        title="批导数据"
        :custome-config="() => vxeShowCustom('xTable')"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <template #button>
          <table-button name="download" tip="模版下载" @click="downloadTemplate('clientApproveImport', '要货审批人员批导模版')" />
          <table-button name="import" tip="批导" @click="handleImportExcel('clientApproveImport')" />
          <table-button name="save" tip="保存" @click="handleSaveImportExcel" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="440"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.gridOptions.columns"
          :data="gridOptions.gridOptions.data"
        >
          <!-- <template #toolbar /> -->
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>
<script>
import {
  apiExportExcelTemplate,
  apiExcelImport,
  apiGetExcelImportData,
  apiSaveExcelImportData
} from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'

export default {
  data() {
    return {
      conditions: {
        templateCode: 'clientOrg',
        batchNumber: ''
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      loading: false,
      gridOptions: {
        buttons: [],
        gridOptions: {
          border: false,
          highlightHoverRow: true,
          resizable: true,
          showOverflow: true,
          height: 'auto',
          maxHeight: '240',
          align: 'center',
          size: 'mini',
          emptyText: '暂时没数据',
          columns: [
            {
              field: 'customerCode',
              title: '客户编号',
              width: 100
            },
            {
              field: 'customerName',
              title: '客户名称',
              width: 120
            },
            {
              field: 'channelManager',
              title: '渠道经理账号',
              width: 100
            },
            {
              field: 'channelManagerName',
              title: '渠道经理名称',
              width: 110
            },
            {
              field: 'baseManager',
              title: '基地经理账号',
              width: 150
            },
            {
              field: 'baseManagerName',
              title: '基地经理名称',
              width: 120

            },
            {
              field: 'areaManager',
              title: '战区经理账号',
              width: 100
            },
            {
              field: 'areaManagerName',
              title: '战区经理名称',
              width: 120
            },
            {
              field: 'corePlanPeople',
              title: '中心计划专员账号1',
              width: 130
            },
            {
              field: 'corePlanPeopleName',
              title: '中心计划专员名称1',
              width: 150
            },
            {
              field: 'corePlanPeople2',
              title: '中心计划专员账号2',
              width: 130
            },
            {
              field: 'corePlanPeople2Name',
              title: '中心计划专员名称2',
              width: 150
            },
            {
              field: 'affairPlanPeople',
              title: '销售内勤账号',
              width: 100
            },
            {
              field: 'affairPlanPeopleName',
              title: '销售内勤名称',
              width: 350
            },
            {
              field: 'reservedCode1',
              title: '预留人员1账号',
              width: 150
            },
            {
              field: 'reservedName1',
              title: '预留人员1名称',
              width: 150
            },
            {
              field: 'reservedCode2',
              title: '预留人员2账号',
              width: 150
            },
            {
              field: 'reservedName2',
              title: '预留人员2名称',
              width: 150
            }
          ],
          data: [],
          editConfig: { trigger: 'click', mode: 'cell' }
        },
        columnsField: 'chanPinMingCheng',
        columnsFields: {
          default: {
            datasource: 'custom',
            defaultVal: '',
            options: [
              { val: '1', label: '选项一', checked: false },
              { val: '2', label: '选项二', checked: false }
            ]
          }
        },
        columnsFieldTypes: { default: '' },
        fieldsEdit: { default: false, chanPinMingCheng: false },
        fields: {
          datasource: 'custom',
          defaultVal: '',
          options: [
            { val: '1', label: '选项一', checked: false },
            { val: '2', label: '选项二', checked: false }
          ]
        },
        display: true,
        init_query: 'N',
        need_page: 'Y',
        indexRow: true,
        page_size: 20
      }
    }
  },
  methods: {
    // 模板下崽
    async downloadTemplate(type, fileName) {
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    conditionChanged(value) {
      this.pagination = {
        page: 1,
        pagesize: 50,
        totalCount: 0
      }
    },
    // 处理分页事件
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.handleQueryImportExcel()
    },
    // 导入excel
    async handleImportExcel(code) {
      this.conditions.templateCode = code
      // this.$refs.xTable.refreshColumn()
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.conditions.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.conditions.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const { page, pagesize } = this.pagination
      const params = { ...this.conditions, page, pagesize }
      const res = await apiGetExcelImportData(params)
      this.gridOptions.gridOptions.data = res.data.Rows
      this.pagination.totalCount = res.data.Total
    },
    // 将导入临时表的数据保存到正式业务表
    async handleSaveImportExcel() {
      if (this.gridOptions.gridOptions.data.length) {
        const formData = new FormData()
        const { batchNumber, templateCode } = this.conditions
        formData.append('batchNumber', batchNumber)
        formData.append('templateCode', templateCode)
        const res = await apiSaveExcelImportData(formData)
        if (res.status === 1) {
          this.$message.success('保存成功!')
        }
      } else {
        this.$message.warning('没有可保存的数据！')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/clientApproveImport.vue